import { call, put, takeLatest } from 'redux-saga/effects';
import {
  setUserData,
  UserDataState,
} from '../GlobalRedux/Features/userData/userDataSlice';
import { getAccessTokenForGraph } from '~/utils/auth';
import { SagaIterator } from 'redux-saga';

interface GraphData {
  id: string;
  displayName: string;
  mail: string;
  userPrincipalName: string;
  // Adicione outros campos conforme necessário
}

function* fetchGraphData(accessToken: string): SagaIterator<GraphData> {
  const response = yield call(fetch, 'https://graph.microsoft.com/v1.0/me', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const data: GraphData = yield call([response, response.json]);
  return data;
}

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

function* fetchProfilePhoto(accessToken: string): SagaIterator<string> {
  const response = yield call(
    fetch,
    'https://graph.microsoft.com/v1.0/me/photo/$value',
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  const blob: Blob = yield call([response, response.blob]);
  const base64String: string = yield call(blobToBase64, blob);
  return base64String;
}

function* fetchPlugins() {
  /* const userData: UserDataState = yield select(state => state.userData);
  const Plugins: UserDataState = yield select(state => state.userData.plugins); */

  try {
    const accessToken: string = yield call(getAccessTokenForGraph);
    const graphData: GraphData = yield call(fetchGraphData, accessToken);
    console.log('graph data: ', graphData);
    const photoBase64: string = yield call(fetchProfilePhoto, accessToken);
    console.log('photo base 64: ', photoBase64);

    // Mapeia os dados do Graph para o formato UserDataState
    const userData = {
      id: graphData.id,
      name: graphData.displayName,
      email: graphData.mail || graphData.userPrincipalName,
      photo: photoBase64,
    };

    yield put(setUserData(userData));
    //yield put(loadPlugins(response.plugins));
  } catch (error) {
    console.error('Erro ao buscar os dados de plugins', error);
  }
}

export function* userDataSaga() {
  yield takeLatest('userData/fetchPlugins', fetchPlugins);
}
